import { render, staticRenderFns } from "./check_box.vue?vue&type=template&id=09480cca&lang=pug"
import script from "./check_box.vue?vue&type=script&lang=js"
export * from "./check_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports